import {configureStore} from '@reduxjs/toolkit';
import {
  headerLogoSlice,
  headerLogoAltTextSlice,
  headerLogoHeadingSlice,
  isBrandingAppliedSlice,
  footerLeftMarkdownSlice,
  footerRightMarkdownSlice,
  faviconSlice,
} from './reducers/brandingReducers';
import {useDispatch, useSelector} from 'react-redux';

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Use throughout app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();

export const store = configureStore({
  reducer: {
    isBrandingApplied: isBrandingAppliedSlice.reducer,
    headerLogo: headerLogoSlice.reducer,
    headerLogoAltText: headerLogoAltTextSlice.reducer,
    headerLogoText: headerLogoHeadingSlice.reducer,
    footerLeftMarkdown: footerLeftMarkdownSlice.reducer,
    footerRightMarkdown: footerRightMarkdownSlice.reducer,
    favicon: faviconSlice.reducer,
  },
});
